import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21762caf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "标准抽奖", -1))
const _hoisted_3 = { class: "drawer_content" }
const _hoisted_4 = { class: "drawer_action_group" }
const _hoisted_5 = {
  key: 0,
  class: "drawer_list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "drawer_item_content" }
const _hoisted_8 = { class: "drawer_item_content_img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "drawer_item_content_tbody" }
const _hoisted_11 = { class: "dict_title mod_ellip" }
const _hoisted_12 = { class: "dict_num" }
const _hoisted_13 = { class: "dict_time_group" }
const _hoisted_14 = {
  key: 0,
  class: "open_time"
}
const _hoisted_15 = {
  key: 1,
  class: "open_time"
}
const _hoisted_16 = { class: "drawer_item_conten_action" }
const _hoisted_17 = { class: "item_select_arrow" }
const _hoisted_18 = {
  key: 0,
  class: "baseline"
}
const _hoisted_19 = {
  key: 1,
  class: "null_box"
}
const _hoisted_20 = ["src"]

import { computed, onUnmounted, reactive, ref } from 'vue';
import { Button, Modal, message, Switch } from 'ant-design-vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { Applicant, Logttery, ViewFormClass } from './lottery';
import CreateStandLogttery from './CreateStandLogttery.vue';
import http from '@/api';
import router from '@/router';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'StandLogttery',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const studioId = router.currentRoute.value.params.studioId;

const aButton = Button;
const aSwitch = Switch;

const onClose = () => {
  emit('click:onCloseLotter');
};

const logtter = ref<Logttery[]>([]);
const participate = ref();
const lastPage = ref(); //最后一页
const loadpageSize = ref(1); //第几页
const noMore = ref(false); //判断是否有更多数据
// 获取抽奖列表
const getDrawList = (current: any) => {
  const data = {
    studio_id: studioId,
    page: current,
    page_num: 7,
  };
  http.lottery.getDrawList({ params: data }).then((res) => {
    participate.value = res.data.data.num;
    res.data.data.list.data ? logtter.value.push(...res.data.data.list.data) : [];
    lastPage.value = res.data.data.list.last_page;
    beginTimer();
  });
};
getDrawList(1);
//滚动加载数据
const getChildList = () => {
  if (loadpageSize.value >= lastPage.value) {
    noMore.value = true;
  } else {
    noMore.value = false;
    loadpageSize.value++;
    getDrawList(loadpageSize.value);
  }
};
// 开奖
const drawPrize = ref(false);
const isOpen = (status: number) => {
  return status === 1 || status === 2;
};
const onChangeDraw = useDebounce((item: any, i: number) => {
  message.destroy();
  if (logtter.value[i].status === 3) {
    message.error('已开过奖的不能再编辑，请新建一个抽奖');
  } else if (logtter.value[i].status === 2) {
    logtter.value[i].status = 3;
    const data = {
      studio_id: studioId,
      title: item.title,
      status: 0,
      switch: 1,
      fixed: 0,
      id: item.id,
      local_join: 0,
    };
    http.lottery
      .createDraw(data)
      .then((res) => {
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else if (logtter.value.some((e) => e.status === 1) && logtter.value[i].status !== 1) {
    message.error('仅能开启一个抽奖');
  } else if (logtter.value.some((e) => e.status === 2) && logtter.value[i].status !== 2) {
    message.error('仅能开启一个抽奖');
  } else {
    logtter.value[i].status = logtter.value[i].status === 0 ? 1 : 0;
    const data = {
      studio_id: studioId,
      title: item.title,
      status: item.status ? 1 : 0,
      switch: 1,
      fixed: 0,
      id: item.id,
      local_join: 0,
    };
    http.lottery
      .createDraw(data)
      .then((res) => {
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
});
const drawId = ref();
const drawIndex = ref();
const onOpenDraw = (item: any, i: number) => {
  message.destroy();
  drawId.value = item.id;
  drawIndex.value = i;
  drawPrize.value = true;
  if (logtter.value[i].status === 2) {
    message.error('已开过奖的不能再编辑，请新建一个抽奖');
  }
};
//  手动开奖
const openDraw = () => {
  message.destroy();
  drawPrize.value = false;
  const data = {
    studio_id: studioId,
    id: drawId.value,
  };
  http.lottery
    .openDraw(data)
    .then((res) => {
      message.success(res.data.message);
      logtter.value[drawIndex.value].status = 2;
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 筛选标记
const selectKeys = ref({});
const delIds = ref();
const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
      delIds.value = selectArr.toString();
    }
  });
  return selectArr.join(',');
});
const getSelected = computed(() => Boolean(!getSelectIds.value));
const choice = ref(false);
const isSelect = computed(() => (choice.value ? 'item_select' : ''));
const isSelected = (data: Logttery) => (selectKeys.value[data.id] ? 'item_selected' : '');
const changeItemMark = (item: Logttery) => {
  if (choice.value) {
    selectKeys.value[item.id] = !selectKeys.value[item.id];
  }
};
/**
 * @description 初始化
 */
const getList = () => {
  selectKeys.value = {};
  choice.value = false;
  logtter.value.forEach((e: Logttery) => {
    selectKeys.value[e.id] = false;
  });
};
getList();
// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const onRemoveSLItem = () => {
  delModal.loading = false;
  delModal.visible = false;
  const data = {
    ids: delIds.value,
    studio_id: studioId,
  };
  http.lottery
    .delDraw(data)
    .then((res) => {
      message.success(res.data.message);
      loadpageSize.value = 1;
      logtter.value = [];
      getDrawList(1);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
  // test
  getList();
};
// 重置
const reset = ref(false);
const drawNoReset = ref();
const openReset = (drawNo: string) => {
  drawNoReset.value = drawNo;
  reset.value = !reset.value;
};
const onReset = () => {
  const data = {
    studio_id: studioId,
    draw_no: drawNoReset.value,
  };
  http.lottery.drawReset(data).then((res) => {
    reset.value = false;
    message.success(res.data.message);
    loadpageSize.value = 1;
    logtter.value = [];
    getDrawList(1);
  });
};
// 倒计时模块
const IntervalKey = ref<any>(0);
const beginTimer = () => {
  clearInterval(IntervalKey.value);
  function addZero(i: number) {
    return i < 10 ? `0${i}` : i;
  }
  if (logtter.value.length > 0) {
    IntervalKey.value = setInterval(() => {
      logtter.value.forEach((element, index) => {
        // 当前时间距离活动开始时间的差值
        if (element.open > 0) {
          element.open--;
          const day = parseInt((element.open / (24 * 60 * 60)).toString(), 10);
          const hour = parseInt(((element.open / (60 * 60)) % 24).toString(), 10);
          const minute = parseInt(((element.open / 60) % 60).toString(), 10);
          const second = parseInt((element.open % 60).toString(), 10);
          // console.log(element.open);
          element.startTime = `${addZero(day)}天${addZero(hour)}时${addZero(minute)}分${addZero(second)}秒`;
        } else {
          element.startTime = '00天00时00分00秒';
        }
      });
    }, 1000);
  }
};

// 二级页面
const secPage = ref(false);
const addPageVisible = ref(false);
const onId = ref(0);

const callbackPage = () => {
  secPage.value = false;
  addPageVisible.value = false;
  loadpageSize.value = 1;
  logtter.value = [];
  getDrawList(1);
};
const onBack = () => {
  secPage.value = false;
  addPageVisible.value = false;
};
onUnmounted(() => {
  clearInterval(IntervalKey.value);
});

const applicants = ref<Applicant>({
  fixed: 0, //内定名单 报名人数
  local: 0, // 本地名单 报名人数
  user: 0, // 观众参与 报名人数
});
const drawForm = ref<ViewFormClass>({
  autoDraw: false, // 自动开奖 0关 1开
  drawNo: '', //抽奖单号
  endAt: null,
  filter: false, //过滤中奖观众
  fixed: false, //内定中将
  id: 0,
  localJoin: false, // 本地名单
  numberWin: 0, //中奖人数
  pic: 0, // 图片id
  picUrl: '', //图片链接
  signJoin: false, //内定
  status: 0, // 0关 1开 2已开奖 3已开奖且关闭
  title: '',
  userJoin: false, // 观众参与
  winHistory: false, //允许查看中奖历史
});
const getMemberNum = () => {
  const number = {
    studio_id: studioId,
  };
  http.lottery.getMemberNum({ params: number }).then((res) => {
    applicants.value = res.data.data;
  });
};
const onOpenAddPage = () => {
  drawForm.value = {
    autoDraw: false, // 自动开奖 0关 1开
    drawNo: '', //抽奖单号
    endAt: null,
    filter: false, //过滤中奖观众
    fixed: false, //内定中将
    id: 0,
    localJoin: false, // 本地名单
    numberWin: 0, //中奖人数
    pic: 0, // 图片id
    picUrl: '', //图片链接
    signJoin: false, //内定
    status: 0, // 0关 1开 2已开奖 3已开奖且关闭
    title: '',
    userJoin: false, // 观众参与
    winHistory: false, //允许查看中奖历史
  };
  onId.value = 0;
  const number = {
    studio_id: studioId,
  };
  http.lottery.getMemberNum({ params: number }).then((res) => {
    applicants.value = res.data.data;
    secPage.value = true;
    addPageVisible.value = true;
  });
};
const onOpenSetPage = (id: number) => {
  getMemberNum();
  onId.value = id;
  const data = {
    id: id,
    studio_id: studioId,
  };
  http.lottery.getDrawWiew({ params: data }).then((res) => {
    drawForm.value = new ViewFormClass(res.data.data);
    secPage.value = true;
    addPageVisible.value = true;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(aButton), {
          type: "link",
          class: "drawer_title_close",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CloseOutlined))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_unref(aButton), {
              class: "drawer_action_btn lg",
              onClick: onOpenAddPage
            }, {
              default: _withCtx(() => [
                _createTextVNode("新建抽奖")
              ]),
              _: 1
            }),
            _createVNode(_unref(aButton), {
              class: _normalizeClass(["drawer_action_btn", { checked: choice.value === true }]),
              onClick: _cache[0] || (_cache[0] = () => (choice.value = !choice.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode("选择")
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_unref(aButton), {
              class: "drawer_action_btn",
              disabled: _unref(getSelected),
              onClick: openDelModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("span", null, "参与人数: " + _toDisplayString(participate.value) + "人", 1)
        ]),
        (logtter.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logtter.value, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["drawer_item", [_unref(isSelect), isSelected(item)]]),
                  onClick: ($event: any) => (changeItemMark(item))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: item.pic_url,
                        width: "66",
                        height: "66",
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1),
                        _createVNode(_unref(aSwitch), {
                          checked: isOpen(item.status),
                          class: "dict_title_switch",
                          "checked-children": "开",
                          "un-checked-children": "关",
                          onChange: ($event: any) => (_unref(onChangeDraw)(item, index))
                        }, null, 8, ["checked", "onChange"])
                      ]),
                      _createElementVNode("p", _hoisted_12, "名额：" + _toDisplayString(item.number_win), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, "开奖时间：" + _toDisplayString(item.end_at), 1),
                        _createElementVNode("div", null, [
                          _createTextVNode(" 开奖倒计时："),
                          (item.end_at === '不限')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "无"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.startTime), 1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (item.status < 2)
                      ? (_openBlock(), _createBlock(_unref(aButton), {
                          key: 0,
                          type: "link",
                          class: "dica_link_btn",
                          onClick: ($event: any) => (onOpenSetPage(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_unref(aButton), {
                          key: 1,
                          type: "link",
                          class: "dica_link_btn",
                          onClick: ($event: any) => (onOpenSetPage(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("详情")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])),
                    _createVNode(_unref(aButton), {
                      type: "link",
                      class: "dica_link_btn",
                      onClick: ($event: any) => (openReset(item.draw_no))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(aButton), {
                      class: "dica_sub",
                      type: "primary",
                      disabled: item.status > 1,
                      onClick: ($event: any) => (onOpenDraw(item, index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.status > 1 ? '已开奖' : '立即开奖'), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_svg_icon, {
                      class: "item_select_arrow_icon",
                      "icon-class": "checked"
                    })
                  ])
                ], 10, _hoisted_6)), [
                  [_directive_infinite_scroll, getChildList]
                ])
              }), 128)),
              (noMore.value && logtter.value.length > 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, "我是有底线的-.-"))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("img", {
                src: _unref(emptyDataSec),
                class: "null_img"
              }, null, 8, _hoisted_20)
            ]))
      ]),
      _createVNode(CDelModal, {
        visible: drawPrize.value,
        centered: "",
        close: () => (drawPrize.value = false),
        ok: openDraw
      }, {
        title: _withCtx(() => [
          _createTextVNode("是否确定立即开奖?")
        ]),
        _: 1
      }, 8, ["visible", "close"]),
      _createVNode(CDelModal, {
        visible: reset.value,
        centered: "",
        close: openReset,
        ok: onReset
      }, {
        title: _withCtx(() => [
          _createTextVNode("此操作将重置该抽奖, 是否继续?")
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(CDelModal, {
        visible: delModal.visible,
        centered: "",
        close: openDelModal,
        ok: onRemoveSLItem
      }, null, 8, ["visible"])
    ], 512), [
      [_vShow, !secPage.value]
    ]),
    (secPage.value && addPageVisible.value)
      ? (_openBlock(), _createBlock(CreateStandLogttery, {
          key: 0,
          data: { applicants: applicants.value, drawForm: drawForm.value, id: onId.value },
          "onClick:callbackPage": callbackPage,
          "onClick:back": onBack
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})